import apontamentoColetasLocalizacaoReport from "entity/Indicador/reports/ApontamentoColetasLocalizacaoReport";
import apontamentoHeaderLocalizacaoReport from "entity/Indicador/reports/ApontamentoHeaderLocalizacaoReport";
import apontamentoImagesReport from "entity/Indicador/reports/ApontamentoImagesReport";
import apontamentoObservacaoReport from "entity/Indicador/reports/ApontamentoObservacaoReport";
import apontamentoPontosAmostradosReport from "entity/Indicador/reports/ApontamentoPontosAmostradosReport";
import TableReportHelper from "report/helper";

export default async function ACReport(indicador, visita) {
    const h = new TableReportHelper(visita.data);
    const IndicadorClass = indicador.constructor;

    const apontamentos = visita.getApontamentosByIndicador(indicador);

    const content = [];

    for (const apontamento of apontamentos) {
        const params = visita.cliente.getParams(IndicadorClass, apontamento.tipo, indicador.type);
        const paramItems = visita.cliente.getParamItems(IndicadorClass, apontamento.tipo);

        const configIndicador = {
            showTrator: true,
            showMeta: true,
            showImplemento: true,
            showFrente: false,
            addHeaderField: [
                {
                    field: "dosagemRecomendada",
                    label: "Dosagem",
                    width: 90,
                    valueGetter: (a) => {
                        return a.dosagemRecomendada;
                    },
                },
                {
                    field: "qtdBandejas",
                    label: "Quant. Bandejas",
                    width: 90,
                    valueGetter: (a) => {
                        return a.qtdBandejas;
                    },
                },
            ],
        };

        let configTituloColunas;
        let configColunasColetas;
        let configTamanhoColunas;

        if (apontamento?.quantidadeColetas === "2") {
            configTituloColunas = ["Coleta 1", "Coleta 2"];
            configColunasColetas = (h) => [
                h.numberField("coleta1", { digits: 3 }),
                h.numberField("coleta2", { digits: 3 }),
            ];
            configTamanhoColunas = ["*", "*"];
        }

        if (apontamento?.quantidadeColetas === "3") {
            configTituloColunas = ["Coleta 1", "Coleta 2", "Coleta 3"];
            configColunasColetas = (h) => [
                h.numberField("coleta1", { digits: 3 }),
                h.numberField("coleta2", { digits: 3 }),
                h.numberField("coleta3", { digits: 3 }),
            ];
            configTamanhoColunas = ["*", "*", "*"];
        }

        if (apontamento?.quantidadeColetas === "4") {
            configTituloColunas = ["Coleta 1", "Coleta 2", "Coleta 3", "Coleta 4"];
            configColunasColetas = (h) => [
                h.numberField("coleta1", { digits: 3 }),
                h.numberField("coleta2", { digits: 3 }),
                h.numberField("coleta3", { digits: 3 }),
                h.numberField("coleta4", { digits: 3 }),
            ];
            configTamanhoColunas = ["*", "*", "*", "*"];
        }

        const additionalColumn = {
            label: "Operador",
            field: "operador.operador",
            width: "*",
        };

        content.push([
            await apontamentoHeaderLocalizacaoReport(
                visita,
                indicador,
                apontamento,
                params,
                "Conformidade Média %",
                configIndicador,
                additionalColumn,
            ),

            await apontamentoColetasLocalizacaoReport(
                visita,
                indicador,
                apontamento,
                configTituloColunas,
                configColunasColetas,
                configTamanhoColunas,
            ),
            apontamentoPontosAmostradosReport(visita, indicador, apontamento, paramItems, "cm"),
            apontamentoImagesReport(visita, indicador, apontamento),
            apontamentoObservacaoReport(visita, indicador, apontamento),

            h.space(),
        ]);
    }

    return content;
}
